import { IRequest } from '@r1-frontend/shared/types/IRequest';
export type { ResponseDto } from './dto/ResponseDto';
export { EConnectionType } from './dto/ResponseDto';

/**
 * Получение типа подключения
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Services%20Settings/cf996f393bafe928d872f910d743a003
 * */
export const connectionType = (): IRequest => ({
    uri: '/v1/services-settings/connection-type',
    method: 'POST',
    withAuth: true,
    withProvider: true,
});
